import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardHeader, CardSection } from 'foundations-components/transitional/components/Card';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { CollectionCardWrapper } from './CollectionCardWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CollectionCard({
  collection,
  maxHeight
}) {
  if (!collection.publishedListing) {
    return null;
  }
  return /*#__PURE__*/_jsxs(CollectionCardWrapper, {
    children: [/*#__PURE__*/_jsx(Ribbon, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-common.collections.collectionLabel"
      })
    }), /*#__PURE__*/_jsx(CardHeader, {
      title: collection.publishedListing.name,
      titleSize: "small",
      marginBlockStart: "400"
    }), /*#__PURE__*/_jsx(DescriptionWrapper, {
      maxHeight: maxHeight,
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: collection.publishedListing.description,
        WrapperComponent: "span"
      })
    })]
  });
}
function DescriptionWrapper({
  children,
  maxHeight
}) {
  if (maxHeight === undefined) {
    return /*#__PURE__*/_jsx(CardSection, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(CardSection, {
    paddingBlockEnd: "200",
    children: /*#__PURE__*/_jsx(ExpandableText, {
      onCollapseButtonClick: e => e.preventDefault(),
      onExpandButtonClick: e => e.preventDefault(),
      maxHeight: maxHeight,
      children: children
    })
  });
}